import { DeviceType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { ChannelBox } from '../../../components/channel/box';
import { DeviceChannelsBox } from '../../../components/channel/device-channels-box';
import { useExalusStorageContext } from '../../../context/storage';
import { DeviceChannelsGrouped } from '../../channel-list/types';

type DashboardChannelsParams = {
  groupChannels?: IDeviceChannel[];
  isDraggable?: boolean;
};

export const useGroupsChannels = ({ groupChannels, isDraggable }: DashboardChannelsParams) => {
  const { isDashboardGridView } = useExalusStorageContext();

  const groupChannelsItems = () => {
    if (groupChannels) {
      const listToMap: IDeviceChannel[] = [];

      for (const channel of groupChannels) {
        if (channel.GetDevice().ShouldChannelsBeGrouped) {
          if (!listToMap.find((x) => x.GetDevice().Guid === channel.GetDevice().Guid)) {
            listToMap.push(channel);
          }
        } else {
          listToMap.push(channel);
        }
      }

      return listToMap
        .map((channel) => {
          const device = channel.GetDevice();

          if (!device.ShouldChannelsBeGrouped) {
            return (
              <ChannelBox
                key={channel.ChannelId}
                channel={channel}
                isListItem={!isDashboardGridView}
                isDraggable={isDraggable}
                hidden={device.DeviceType === DeviceType.Scene ? false : channel.IsHidden}
                showIsHidden={device.DeviceType === DeviceType.Scene ? channel.IsHidden : false}
              />
            );
          } else {
            const item: DeviceChannelsGrouped = {
              id: channel.GetDevice().Guid,
              deviceName: device.Name,
              channels: channel
                .GetDevice()
                .Channels.filter((x) => groupChannels.find((y) => y.ChannelId === x.ChannelId && !x.IsHidden)),
            };

            if (item.channels.length > 0) {
              return (
                <DeviceChannelsBox
                  key={item.id}
                  deviceChannelsGrouped={item}
                  isListItem={!isDashboardGridView}
                  isDraggable={isDraggable}
                />
              );
            }
          }
        })
        .filter((x) => x?.key);
    }
  };

  return {
    groupChannelsItems,
  };
};
